import { render, staticRenderFns } from "./priority-picker.vue?vue&type=template&id=d2a8fc4a&"
import script from "./priority-picker.vue?vue&type=script&lang=ts&"
export * from "./priority-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports